import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between container w-full px-4" }
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"17px","color":"red"} }, "*", -1)
const _hoisted_4 = { class: "flex flex-row justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ps_label = _resolveComponent("ps-label")!
  const _component_ps_input = _resolveComponent("ps-input")!
  const _component_ps_button = _resolveComponent("ps-button")!
  const _component_ps_modal = _resolveComponent("ps-modal")!

  return (_openBlock(), _createBlock(_component_ps_modal, {
    ref: "psmodal",
    maxWidth: "350px",
    isClickOut: false,
    class: "z-50",
    line: "hidden"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ps_label, { class: "mt-4 mx-5" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('register__email')) + " ", 1),
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_ps_input, {
            class: "mt-2 mx-5 mb-4",
            type: "email",
            "v-bindplaceholder": _ctx.$t('password_update_modal__password'),
            value: _ctx.userEmail,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userEmail) = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.actionClicked('yes')), ["enter"])),
            onBlur: _ctx.validateEmail
          }, null, 8, ["v-bindplaceholder", "value", "onBlur"]),
          (_ctx.validationEmail)
            ? (_openBlock(), _createBlock(_component_ps_label, {
                key: 0,
                class: "lg:mt-2 mt-1 w-full",
                textColor: "text-primary-500"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("login__email_required_error")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ps_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.actionClicked('no'))),
          textSize: "text-xxs lg:text-sm",
          class: "py-3",
          theme: "bg-secondary-000 dark:bg-secondaryDark-grey text-primary-500 dark:text-primaryDark-white"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('profile__cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ps_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.actionClicked('yes'))),
          textSize: "text-xxs lg:text-sm",
          class: "py-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('profile__confirm')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 512))
}